import { useState, useMemo, useEffect } from "preact/hooks";
import { Label, Table } from "../../../bpmn.io/@bpmn-io/form-js-viewer";
import classNames from "../../../bpmn.io/classnames";
import{ html } from 'htm/preact';
import { AppData } from "../../helpers/app-data";

function _bspEnsureSpinnerStyle() {
  if (!document.getElementById('_bsp-spin-style')) {
    const s = document.createElement('style');
    s.id = '_bsp-spin-style';
    s.textContent = '@keyframes _bspSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }
}
function _bspCreateSpinner() {
  const wrap = document.createElement('div');
  wrap.style.cssText = 'display:flex;align-items:center;justify-content:center;height:120px;width:100%;';
  const ring = document.createElement('div');
  ring.style.cssText = 'width:48px;height:48px;border:5px solid #e0e0e0;border-top-color:#0078d4;border-radius:50%;animation:_bspSpin 0.8s linear infinite;';
  wrap.appendChild(ring);
  return wrap;
}

export const type = "feedbackButton";

export function FeedbackTableRenderer(props) {
  const { disabled, readonly, field } = props;
  const { message } = field;

  const { columnsExpression, columns = [], id, label } = props.field;
  const shouldUseMockColumns =
    (typeof columnsExpression === "string" && columnsExpression.length > 0) ||
    (Array.isArray(columns) && columns.length === 0);

  const editorColumns = shouldUseMockColumns
    ? [
        { key: "1", label: "Column 1" },
        { key: "2", label: "Column 2" },
        { key: "3", label: "Column 3" },
      ]
    : columns;

  const prefixId = `fjs-form-${id}`;

  const [data, setData] = useState([]);
  const [serviceColumns, setServiceColumns] = useState([]);
  const visibleColumns = ["NombreDocumento"];
  const AditionalColumns = [{'label': 'Aprobado', 'controlType': 'checkBox', 'position': 0}, {'label': 'Observaciones', 'controlType': 'textBox', 'position': -1}];
  const [isButtonVisible, setIsButtonVisible] = useState(true); // Estado para controlar la visibilidad del botón

  function updateGlobalData(data) {
    window.globalData = data;
    if (window.onGlobalDataUpdate) {
      window.onGlobalDataUpdate(data);
    }
  }

  // Asignar la función al objeto global window para que pueda ser accedida globalmente
  window.updateGlobalData = updateGlobalData;

  // Function to fetch data
  const fetchData = (idEjecucion) => {
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);
    if (!API_TOKEN) {
      console.error("API token not found");
      return;
    }
    //Cambiar esto a como estaba Cristian Jimenez
    const url = `${AppData.API_URL}EjecucionProceso/DocumentosEjecucionProceso?IdEjecucion=${idEjecucion}`;
    // const url = `${AppData.API_URL}EjecucionProceso/DocumentosEjecucionProceso?IdEjecucion=${2102}`;
    /* const url = `${AppData.API_URL}EjecucionProceso/DocumentosEjecucionProceso?IdEjecucion=9`; */
    const headers = {
      "Content-Type": "application/json",
      "X-APIKey": AppData.API_KEY,
      Authorization: `Bearer ${API_TOKEN}`,
    };

    fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((responseData) => {
        
        if (responseData.Data.length > 0) {
          const firstItem = responseData.Data[0];
          const columns = Object.keys(firstItem)
            .filter((key) => visibleColumns.includes(key))
            .map((key) => ({
              key,
              label: key.charAt(0).toUpperCase() + key.slice(1),
            }));

          if(AditionalColumns)
          {
            AditionalColumns.forEach(column => {
              if(column.position == 0)
              {
                columns.splice(0,0,{ key: column.label, label: column.label});
              }
              else
              {
                columns.push({ key: column.label, label: column.label});
              }
            })
          }

          responseData.Data.forEach(item => {
            item['Aprobado'] = false;
            item['Observaciones'] = '';
          })

          setServiceColumns(columns);
        }
        updateGlobalData(responseData.Data);
        setData(responseData.Data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  useEffect(() => {
    const baseService = window.baseService;
    if (baseService) {
      const subscription = baseService.currentTablaArchivosVisible.subscribe(
        (isVisible) => {
          if (!isVisible) {
            setIsButtonVisible(isVisible);
          }
        }
      );
      const subscriptionData = baseService.currentIdEjecucionProceso.subscribe(
        (idEjecucionProceso) => {
          if (idEjecucionProceso) {
            fetchData(idEjecucionProceso);
          }
        }
      );

      return () => {subscription.unsubscribe(), subscriptionData.unsubscribe()};

    }
  }, []);

  // useMemo(() => {
  //   // Acceder al servicio Angular desde el window global
  //   const baseService = window.baseService;
  //   if (baseService) {
  //     const subscription = baseService.currentIdEjecucionProceso.subscribe(
  //       (idEjecucionProceso) => {
  //         if (idEjecucionProceso) {
  //           fetchData(idEjecucionProceso);
  //         } else {
  //           //eliminar
  //           fetchData(9);

  //         }
  //       }
  //     );

  //     return () => subscription.unsubscribe();
  //   }
  // }, []);

  async function descargarDocumentoGeneral(idArchivo, NombreDocumento) {
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken); 
    const headers = {
      "Content-Type": "application/json",
      "X-APIKey": AppData.API_KEY,
      Authorization: `Bearer ${API_TOKEN}`,
      Accept: "application/octet-stream",
    };
  
    try {
      const response = await fetch(
        `${AppData.API_URL}EjecucionProceso/ConsultarDocumentoBestDoc?IdDocumentoExpediente=${idArchivo}`,
        {
          method: "GET",
          headers: headers,
        }
      );
  
      if (!response.ok) {
        throw new Error("Error en la respuesta de la red");
      }
  
      const jsonDoc = await response.json();

      if(jsonDoc.Data[0].Archivo[0].TipoResutado != 'None')
      {   
        let results = await axios({
          url: jsonDoc.Data[0].Archivo[0].DatosArchivo,
          method: 'GET',
          responseType: 'blob'
        })
        // Crear un enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([results.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = NombreDocumento;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a); // Remover el enlace del DOM
        $('#documentContent').html();
        $('#documentContent').hide();
      }
      else
      {
        $('#documentContent').html(`<p style="color: brown; display: none;">${jsonDoc.Data[0].Archivo[0].DatosArchivo}</p>`);
        $('#documentContent').show();
      }


      
     
    } catch (error) {
      console.error("Error descargando el documento", error);
    }
  }

  const setApprobalDocument = (id) => {
    
    let test = data.filter(x => x.Id == id);
    test[0]['Aprobado'] = $("#Aprob_"+id).prop( "checked" );

    updateGlobalData(data);
  };

  const setObsDocument = (id) => {
    
    let test = data.filter(x => x.Id == id);
    test[0]['Observaciones'] = $("#Obs_"+id).val();

    updateGlobalData(data);
  };

  const handleOpenDocument = (id) => {
    console.log(id);
    
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);
    const url = `${AppData.API_URL}EjecucionProceso/ConsultarDocumentoBestDoc?IdDocumentoExpediente=${id}`;
    const headers = {
      "Content-Type": "application/json",
      "X-APIKey": AppData.API_KEY,
      Authorization: `Bearer ${API_TOKEN}`,
      Accept: "application/octet-stream",
    };

    fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
        //return response.blob();
      })
      .then((responseData) => {
      //.then((blob) => {
        
        //const blobUrl = URL.createObjectURL(blob);
        if(responseData.Data[0].Archivo[0].TipoResutado != 'None')
        {
          const blobUrl = responseData.Data[0].Archivo[0].DatosArchivo;
          const _extUrl3 = blobUrl.toLowerCase().replace(/\?.*$/, '');
          // Archivos comprimidos: sin visor disponible en el navegador → descargar directamente
          if (/\.(zip|rar|7z)$/.test(_extUrl3)) {
            const _dlA3 = document.createElement('a');
            _dlA3.href = blobUrl;
            _dlA3.download = blobUrl.split('/').pop()?.split('?')[0] || 'archivo';
            _dlA3.target = '_blank';
            _dlA3.style.display = 'none';
            document.body.appendChild(_dlA3);
            _dlA3.click();
            document.body.removeChild(_dlA3);
            const _dcZip3 = document.getElementById('documentContent');
            if (_dcZip3) {
              _dcZip3.innerHTML = '<p style="padding:1em;color:#555;">Archivo comprimido — la descarga ha iniciado.</p>';
              _dcZip3.style.display = 'block';
            }
            return;
          }
          let _viewerEl3;
          if (/\.(png|jpe?g|gif|webp|svg|bmp|ico)$/.test(_extUrl3)) {
            _viewerEl3 = document.createElement('img');
            _viewerEl3.style = 'max-width: 100%; max-height: 30em; display: block; margin: auto; padding: 1em;';
            _viewerEl3.src = blobUrl;
          } else {
            _viewerEl3 = document.createElement('iframe');
            _viewerEl3.style = 'width: 100%; height: 30em; padding: 2em; border: none;';
            if (/\.(xlsx?|docx?|pptx?|csv)$/.test(_extUrl3)) {
              _viewerEl3.src = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(blobUrl);
            } else if (/\.(pdf|txt|html?|xml)$/.test(_extUrl3)) {
              _viewerEl3.src = blobUrl;
            } else {
              _viewerEl3.src = 'https://docs.google.com/gview?url=' + encodeURIComponent(blobUrl) + '&embedded=true';
            }
          }
          const _dcEl5 = document.getElementById('documentContent');
          if (_dcEl5) {
            _dcEl5.innerHTML = '';
            _bspEnsureSpinnerStyle();
            const _sp3 = _bspCreateSpinner();
            _dcEl5.appendChild(_sp3);
            _dcEl5.style.display = 'block';
            _viewerEl3.onload = () => _sp3.remove();
            _dcEl5.appendChild(_viewerEl3);
          }
        }
        else
        {
          const _dcEl6 = document.getElementById('documentContent');
          if (_dcEl6) _dcEl6.style.display = 'none';
        }

        //window.open(blobUrl, "_blank");
      })
      .catch((error) => {
        console.error("Error fetching document: ", error);
      });
  };

  
  // if (!isButtonVisible || serviceColumns.length <= 0) {
  //   return html`
  //     <div class=${editorFormFieldClasses("table", { disabled: true })}>
  //       <label id=${prefixId} label=${label} />
  //       <div class="fjs-table-middle-container">
  //         <div class="fjs-table-inner-container">
  //           <table
  //             class=${classNames("fjs-table", "fjs-disabled")}
  //             id=${prefixId}
  //           >
  //             <thead class="fjs-table-head">
  //               <tr class="fjs-table-tr">
  //                 <th class="fjs-table-th">NombreDocumento</th>
  //                 <th class="fjs-table-th">Acción</th>
  //               </tr>
  //             </thead>
  //             <tbody class="fjs-table-body"></tbody>
  //           </table>
  //         </div>
  //       </div>
  //     </div>
  //   `;
  // } else {
    return html`
      <div class=${editorFormFieldClasses("table", { disabled: true })}>
        <label id=${prefixId} label=${label} />
        <div class="fjs-table-middle-container">
          <div class="fjs-table-inner-container">
            <table
              class=${classNames("fjs-table", "fjs-disabled")}
              id=${prefixId}
            >
              <thead class="fjs-table-head">
                <tr class="fjs-table-tr">
                  ${(serviceColumns.length > 0
                    ? serviceColumns
                    : editorColumns
                  ).map(
                    (column) => html`
                      <th class="fjs-table-th" key=${column.key}>
                        ${column.label}
                      </th>
                    `
                  )}
                  <th class="fjs-table-th">Acción</th>
                </tr>
              </thead>
              <tbody class="fjs-table-body">
                ${data.map(
                  (row, rowIndex) => html`
                    <tr class="fjs-table-tr docRow" key=${rowIndex}>
                      ${(serviceColumns.length > 0
                        ? serviceColumns
                        : editorColumns
                      ).map(
                        function(column) {

                        let dataBind = false;

                        for(const index in AditionalColumns){

                          if(AditionalColumns[index].label == column.key)
                          {
                            if(AditionalColumns[index].controlType == 'checkBox')
                            {
                              return html`
                              <td class="fjs-table-td">
                                <input type="checkbox" id="Aprob_${row.Id}" onChange=${() => setApprobalDocument(row.Id)}/>
                              </td>`;
                            }
                            else if(AditionalColumns[index].controlType == 'textBox')
                            {
                              return html`
                              <td class="fjs-table-td">
                                <textarea id="Obs_${row.Id}" rows="1" cols="25" onBlur=${() => setObsDocument(row.Id)}></textarea>
                              </td>`;          
                            }        
                          } 
                          else
                          {
                            dataBind = true;
                          }  

                        }
                        
                        if(dataBind)
                        {
                          return html`
                              <td class="fjs-table-td">
                                ${row[column.key]}
                              </td>`;  
                        }

                        } //getAddControl(column.key, row) 

                        
                      )}
                      <td class="fjs-table-td">
                        <button
                          class="ms-CommandButton-button"
                          type="button"
                          onClick=${() => handleOpenDocument(row.IdDocumentoExterno)}
                        >
                          <span
                            class="ms-CommandButton-icon ms-fontColor-themePrimary"
                            ><i class="ms-Icon ms-Icon--View"></i
                          ></span>
                        </button>

                        <button class="ms-CommandButton-button" type="button" onClick=${() => descargarDocumentoGeneral(row.IdDocumentoExterno, row.NombreDocumento)}>
                          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Download"></i></span>
                         </button>

                      </td>
                    </tr>
                  `
                )}
              </tbody>
            </table>
          </div>
        </div>
        <p style="color: brown; display: none;" id='requiredObsError'></p>
      </div>
      <div id="documentContent" style="display:none;"></div>
    `;
  //}
}

FeedbackTableRenderer.config = {
  ...Table.config,
  type: type,
  label: "Tabla Archivos",
  iconUrl: ``,
  propertiesPanelEntries: ["label"],
};

export function editorFormFieldClasses(type, { disabled = false } = {}) {
  if (!type) {
    throw new Error("type required");
  }

  return classNames("fjs-form-field", `fjs-form-field-${type}`, {
    "fjs-disabled": disabled,
  });
}
